import { useEffect, useState } from "react";
import api, { fileUrl } from "@/lib/api";
import { PageHero, Reveal, EmptyState } from "@/components/public/Shared";

export default function History() {
  const [entries, setEntries] = useState(null);

  useEffect(() => {
    api.get("/public/history").then((r) => setEntries(r.data)).catch(() => setEntries([]));
  }, []);

  return (
    <div data-testid="history-page">
      <PageHero
        title="Church History"
        subtitle="The story of God's faithfulness to our congregation through the years."
      />
      <div className="mx-auto max-w-4xl px-5 py-16 sm:px-8 sm:py-24">
        {entries && entries.length === 0 && (
          <EmptyState
            testId="history-empty"
            title="Our history is being written"
            text="The historical timeline of Christ Church CNI, Rajpura will be published here soon. Please check back later."
          />
        )}
        <div className="relative">
          {(entries || []).length > 0 && (
            <div className="absolute left-4 top-0 bottom-0 w-px bg-gold/40 sm:left-1/2" aria-hidden="true" />
          )}
          <div className="space-y-12">
            {(entries || []).map((e, i) => (
              <Reveal key={e.id}>
                <div
                  className={`relative flex flex-col gap-4 pl-12 sm:w-1/2 sm:pl-0 ${
                    i % 2 === 0 ? "sm:pr-12 sm:text-right" : "sm:ml-auto sm:pl-12"
                  }`}
                  data-testid={`history-entry-${e.id}`}
                >
                  <span
                    className={`absolute top-1 left-4 h-3 w-3 -translate-x-1/2 rounded-full bg-gold ring-4 ring-gold/20 ${
                      i % 2 === 0 ? "sm:left-auto sm:-right-1.5 sm:translate-x-1/2" : "sm:-left-1.5 sm:-translate-x-1/2"
                    }`}
                    aria-hidden="true"
                  />
                  <p className="font-heading text-3xl font-black text-gold-dark">{e.year}</p>
                  <h3 className="font-heading text-xl font-bold text-navy">{e.title}</h3>
                  {e.image_url && (
                    <img src={fileUrl(e.image_url)} alt={e.title} className="rounded-lg border border-border object-cover max-h-64 w-full" loading="lazy" />
                  )}
                  <p className="text-sm leading-relaxed text-muted-foreground whitespace-pre-line">{e.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
